import { qualifyUrls } from "routing/Routes";
const OidcRoutes = {
  AUTH_CALLBACK: "/authorization-code/callback"
};
export default {
  ...qualifyUrls(OidcRoutes),
  unqualified: OidcRoutes
};
